import PopupGuest from '@components/popup-guest.vue'
import Vue from 'vue'

const PopupGuestConstructor = Vue.extend(PopupGuest)

const popupGuest = () => {
  return new Promise((resolve, reject) => {
    const popupDom = new PopupGuestConstructor({
      el: document.createElement('div'),
    })
    document.body.appendChild(popupDom.$el)
    var msg = {}
    msg.btn = {
      confirm: 'OK',
    }
    popupDom.confirm = (res) => {
      resolve(res)
      if (msg.confirm) {
        msg.confirm()
      }
      popupDom.showPopup = false
    }
  })
}
export default popupGuest
